import { render, staticRenderFns } from "./ChatSettingsModal.vue?vue&type=template&id=3c613146&scoped=true&"
import script from "./ChatSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ChatSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatSettingsModal.vue?vue&type=style&index=0&id=3c613146&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c613146",
  null
  
)

export default component.exports